<template>
  <AccessRequestsTable
    :rows="accessRequests"
    :loading="isLoading"
    :has-more-items="hasNextPage"
    :search-query="searchQuery"
    :show-row-actions="false"
    :active="(row) => route.params.accessRequestId === row.id"
    @search="onSearch"
    @load="fetchNextPage"
    @click-row="onClickRow"
  />
</template>

<script setup lang="ts">
import { AccessRequest } from '@infuse/api/iam/access-request';
import { Tenant } from '@infuse/api/iam/tenant';
import { useAccessRequests } from '@infuse/iam/access-request/queries';
import { AccessRequestsTable } from '@infuse/iam/access-request/ui';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const props = defineProps<{
  model: Tenant;
}>();

const tenantId = computed(() => props.model?.id);

const { accessRequests, isLoading, hasNextPage, fetchNextPage, searchQuery } = useAccessRequests({
  targetTenantId: tenantId,
  enabled: () => !!tenantId.value
});

function onSearch(query: string): void {
  searchQuery.value = query;
}

function onClickRow(row: AccessRequest): void {
  router.push({
    name: 'tenant.access-requests.details',
    params: { id: tenantId.value, accessRequestId: row.id }
  });
}
</script>
